import { render, staticRenderFns } from "./brand.vue?vue&type=template&id=d4dc44ea&scoped=true&"
import script from "./brand.vue?vue&type=script&lang=js&"
export * from "./brand.vue?vue&type=script&lang=js&"
import style0 from "./brand.vue?vue&type=style&index=0&id=d4dc44ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4dc44ea",
  null
  
)

export default component.exports